export default "__VITE_ASSET__BGRCp$lY__"